import { buildQuery, API_BASE_URL } from "../api/apiClient";
import {
  PARTNER_WHATSAPP_EXPORT_ENABLED,
  PARTNER_WHATSAPP_EXPORT_ROLES,
} from "../constants/partnerWhatsappMonitoringConstants";

function parseContentDispositionFilename(headerValue) {
  if (!headerValue) {
    return null;
  }
  const match = /filename="([^"]+)"/i.exec(headerValue);
  return match?.[1] || null;
}

export function canPartnerWhatsappExport(partner) {
  if (process.env.REACT_APP_AUTOMAPA_PARTNER_WHATSAPP_EXPORTS_ENABLED === "false") {
    return false;
  }
  if (partner?.features && partner.features.whatsappExport !== true) {
    return false;
  }
  if (!PARTNER_WHATSAPP_EXPORT_ENABLED) {
    return false;
  }
  const role = String(partner?.role || "viewer").toLowerCase();
  return PARTNER_WHATSAPP_EXPORT_ROLES.includes(role);
}

export async function downloadPartnerWhatsappExport(path, params = {}) {
  const query = buildQuery({ ...params, format: "csv" });
  const response = await fetch(`${API_BASE_URL}${path}${query}`, {
    credentials: "include",
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || "Request failed");
  }

  const blob = await response.blob();
  const filename =
    parseContentDispositionFilename(response.headers.get("Content-Disposition")) ||
    "automapa-whatsapp-export.csv";
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);
  return filename;
}

export function exportPartnerWhatsappSummaryCsv(params = {}) {
  return downloadPartnerWhatsappExport("/api/partner/automap/whatsapp/export/summary", params);
}

export function exportPartnerWhatsappConversationsCsv(params = {}) {
  return downloadPartnerWhatsappExport("/api/partner/automap/whatsapp/export/conversations", params);
}

export function exportPartnerWhatsappDealerHealthCsv(params = {}) {
  return downloadPartnerWhatsappExport("/api/partner/automap/whatsapp/export/dealers/health", params);
}
